import React, { useState, useEffect } from "react";
import { downloadSubscriberRevenueReport, fetchSubscriberReport, GetCountries } from "../../../api/Api";
import { getFromLocalStorage } from "../../../utils/common-utils";
import CustomTable from "../../../components/Table/CustomTable";
import Swal from "sweetalert2";
import PaginationComponent from "../../../components/Pagination/PaginationComponent";
import "./manageReport.css";

export default function SubscriberReport() {
  const [formData, setFormData] = useState({
    startDate: "",
    selectedCountry: null,
    selectedOperator: null
  });

  const [errors, setErrors] = useState({
    startDate: "",
    selectedCountry: "",
    selectedOperator: ""
  });
  // const [pageSize, setPageSize] = useState(10);
  const [isFormValid, setIsFormValid] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loaders, setLoaders] = useState({
    countryLoader: false,
  });
  const [countryList, setCountryList] = useState([]);
  const [reportData, setReportData] = useState([
    {
      productId: "13",
      productName: "Lipstick",
      totalBase: "Tool Base",
      activeBase: "Active Base",
      graceBase: "Grace Base",
    },
  ]);

  // Add pagination state
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({
    totalElements: 0,
    totalPages: 0
  });
  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [tableConfig, setTableConfig] = useState({
    enabledColumns: [],
    actions: [] // Add actions array even if empty
  });

  const pageSizeArr = [10, 25, 50, 100];

  const validateForm = () => {
    const newErrors = {
      startDate: "",
      selectedCountry: "",
      selectedOperator: ""
    };

    if (!formData.startDate) {
      newErrors.startDate = "Start date is required";
    }

    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    if (formData.startDate && new Date(formData.startDate) > yesterday) {
      newErrors.startDate = "Start date cannot be later than yesterday";
    }

    if (!formData.selectedCountry) {
      newErrors.selectedCountry = "Country is required";
    }

    if (!formData.selectedOperator && formData.selectedCountry?.countryName !== "All") {
      newErrors.selectedOperator = "Operator is required";
    }

    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (isSubmitted) {
      validateForm();
    } else {
      const newErrors = {
        startDate: "",
        selectedCountry: "",
        selectedOperator: ""
      };
      if (!value) {
        newErrors.startDate = "Start date is required";
      }
      if (value && new Date(value) > new Date()) {
        newErrors.startDate = "Start date cannot be in the future";
      }
      setErrors(newErrors);
      setIsFormValid(Object.values(newErrors).every((error) => error === ""));
    }
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setFormData(prev => ({
        ...prev,
        selectedCountry: { countryName: "All", cnUniId: "All" },
        selectedOperator: { operatorName: "All", opUniId: "All" }
      }));
    } else {
      const selectedCountry = countryList.find(country => country.countryName === value);
      setFormData(prev => ({
        ...prev,
        selectedCountry: selectedCountry || null,
        selectedOperator: null
      }));
    }
  };

  const handleOperatorChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setFormData(prev => ({
        ...prev,
        selectedOperator: { operatorName: "All", opUniId: "All" }
      }));
    } else {
      const operator = formData.selectedCountry?.operatorList.find(
        op => op.operatorName === value
      );
      setFormData(prev => ({
        ...prev,
        selectedOperator: operator || null
      }));
    }
  };

  const getCountriesAndOperators = async () => {
    setLoaders((prev) => ({ ...prev, countryLoader: true }));
    try {
      const response = await GetCountries();
      if (response?.statusDescription?.status == 200) {
        setCountryList(response?.countryResponseList);
      } else {
        setCountryList([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountryList([]);
    }
    setLoaders((prev) => ({ ...prev, countryLoader: false }));
  };

  useEffect(() => {
    getCountriesAndOperators();
  }, []);
  console.log("countryList", countryList);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    const isValid = validateForm();
    setIsFormValid(isValid);

    if (isValid) {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        date: formData.startDate,
        pageNo: currentPage,
        pageSize: pageSize,
        countryCode: formData.selectedCountry?.countryName === "All" ? "All" : formData.selectedCountry?.cnUniId,
        operatorCode: formData.selectedOperator?.operatorName === "All" ? "All" : formData.selectedOperator?.opUniId

      };

      try {
        const response = await fetchSubscriberReport(payload);
        if (response?.statusDescription?.status === 200) {
          if (!response.subscriberBaseReport?.content?.length || response.subscriberBaseReport === null) {
            setIsDataAvailable(false);
            setShowDownloadButton(false);
            Swal.fire({
              icon: "info",
              title: "No Data",
              text: "No data found for the selected criteria",
            });
            setTableData([]);
            setTableConfig({
              enabledColumns: response.enabledColumns,
              actions: []
            });
            setPaginationData({
              totalElements: 0,
              totalPages: 0
            });
            return;
          }

          setIsDataAvailable(true);
          setShowDownloadButton(true);
          const mappedData = response.subscriberBaseReport.content.map((item, index) => ({
            ...item,
            sno: currentPage * pageSize + index + 1
          }));

          setTableData(mappedData);
          setTableConfig({
            enabledColumns: response.enabledColumns,
            actions: []
          });
          setPaginationData({
            totalElements: response.subscriberBaseReport.page.totalElements,
            totalPages: response.subscriberBaseReport.page.totalPages
          });
        }
        else if (response?.statusDescription?.status == 201) {
          Swal.fire({
            icon: "info",
            title: "No Data",
            text: response?.statusDescription?.description,
          });
          return;
        }
      } catch (error) {
        console.error("Error fetching report:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch report data",
        });
      }
    }
  };

  const handleDownload = async () => {
    try {
      const payload = {
        userId: getFromLocalStorage("userData")?.id,
        date: formData.startDate,
        pageNo: currentPage,
        pageSize: pageSize,
        countryCode: formData.selectedCountry?.countryName === "All" ? "All" : formData.selectedCountry?.cnUniId,
        operatorCode: formData.selectedOperator?.operatorName === "All" ? "All" : formData.selectedOperator?.opUniId
        , type: "subscriber"
      };

      const response = await downloadSubscriberRevenueReport(payload);
      console.log("response", response);

      if (response?.statusDescription?.status === 200 && response?.fileName) {
        // Create an anchor element
        const link = document.createElement('a');
        link.href = response.fileName;

        // Extract filename from URL
        const filename = response.fileName.split('/').pop();
        link.download = filename;

        // Append to body, click and remove
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to download report. Please try again.',
        });
      }
    } catch (error) {
      console.error('Download error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to download report. Please try again.',
      });
    }
  };

  const handleTableAction = (action, rowData) => {
    // Handle any table actions if needed
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleReset = () => {
    setCurrentPage(0);
    setPaginationData({
      totalElements: 0,
      totalPages: 0
    });
    setIsDataAvailable(false);
    setShowDownloadButton(false);
  };

  return (
    <div className="content-wrapper">
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="box">
              <div className="box-header">
                <div className="row">
                  <div className="col-md-8 col-12">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb breadcrumb_bg">
                        <li className="breadcrumb-item">
                          <a className="breadcrumb_1">Manage Reports</a>
                        </li>
                        <li
                          className="breadcrumb-item active breadcrumb_2 d-flex align-items-center"
                          aria-current="page"
                        >
                         <span> Subscriber Base</span>
                        </li>
                      </ol>
                    </nav>
                  </div>
                  {showDownloadButton && (
                    <div className="col-md-4 col-12 mt_3 d-flex align-items-center justify-content-end">
                      <div className="btn-group float-right">
                        <button
                          type="button"
                          className="btn btn-primary btn-raised btn-flat create_cp"
                          onClick={handleDownload}
                        >
                          Download
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              <div className="box-body">
                <form className="mt-2" onSubmit={handleSubmit} noValidate>
                  <div className="card mt-4 p-3">
                    <span className="mt-2 mb-3 fw-bold badge_head text-center">
                      Subscriber Report
                    </span>
                    <div className="row pt-2 mb-0">
                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                          <label className="">
                            Select Country<sup className="text-danger">*</sup>
                          </label>
                          <select
                            className={`form-select ${isSubmitted && errors.selectedCountry ? "is-invalid" : ""}`}
                            value={formData.selectedCountry?.countryName || ""}
                            onChange={handleCountryChange}
                          >
                            <option value="">Select Country</option>
                            <option value="All">All</option>
                            {countryList.map((country) => (
                              <option
                                key={country.id}
                                value={country.countryName}
                              >
                                {country.countryName}
                              </option>
                            ))}
                          </select>
                          {isSubmitted && errors.selectedCountry && (
                            <div className="invalid-feedback d-block">
                              {errors.selectedCountry}
                            </div>
                          )}
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                          <label className="">
                            Select Operator<sup className="text-danger">*</sup>
                          </label>
                          <select
                            className={`form-select ${isSubmitted && errors.selectedOperator ? "is-invalid" : ""}`}
                            value={formData.selectedCountry?.countryName === "All" ? "All" : formData.selectedOperator?.operatorName || ""}
                            onChange={handleOperatorChange}
                            disabled={!formData.selectedCountry || formData.selectedCountry?.countryName === "All"}
                          >
                            <option value="">Select Operator</option>
                            <option value="All">All</option>
                            {formData.selectedCountry?.operatorList?.map((operator) => (
                              <option
                                key={operator.id}
                                value={operator.operatorName}
                              >
                                {operator.operatorName}
                              </option>
                            ))}
                          </select>
                          {isSubmitted && errors.selectedOperator && (
                            <div className="invalid-feedback d-block">
                              {errors.selectedOperator}
                            </div>
                          )}
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3">
                        {/* <div className="form-group"> */}
                          <label className="">
                            Select Start Date<sup className="text-danger">*</sup>
                          </label>
                          <input
                            type="date"
                            className={`form-control ${isSubmitted && errors.startDate ? "is-invalid" : ""}`}
                            max={new Date(new Date().setDate(new Date().getDate() - 1)).toISOString().split('T')[0]}
                            name="startDate"
                            value={formData.startDate}
                            onChange={handleInputChange}
                          />
                          {isSubmitted && errors.startDate && (
                            <div className="invalid-feedback d-block">
                              {errors.startDate}
                            </div>
                          )}
                        {/* </div> */}
                      </div>

                      <div className="form-group col-sm-3 mt-auto d-flex justify-content-end res_sub">
                        {/* <div className="form-group w-50"> */}
                          <label className="font-weight-bold invisible">
                            Select Date
                          </label>
                          <button
                            type="submit"
                            className="btn btn-primary "
                            disabled={!isFormValid}
                          >
                            Submit
                          </button>
                        {/* </div> */}
                      </div>
                    </div>
                  </div>
                </form>
                {tableData.length > 0 && (
                  <div className="card mt-4 p-3">
                    <div className="dnd-table-container p-0 p-md-3">
                      <div className="form-group d-flex align-items-center justify-content-between gap-2 records">
                        <div className="d-flex">
                          <span>Show</span>
                          <select
                            className="form-select count_select mx-2"
                            value={pageSize}
                            onChange={(e) => {
                              setPageSize(Number(e.target.value));
                              setCurrentPage(0);
                              handleSubmit(new Event('submit'));
                            }}
                            style={{ width: "auto" }}
                          >
                            {[10, 25, 50, 100].map((size) => (
                              <option key={size} value={size}>
                                {size}
                              </option>
                            ))}
                          </select>
                          <span>entries</span>
                        </div>
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary ref_but"
                            onClick={() => handleSubmit(new Event('submit'))}
                          >
                            Refresh &nbsp;
                            <i className="fas fa-sync ms-auto"></i>
                          </button>
                        </div>
                      </div>
                      <div id="table">
                        <CustomTable
                          data={tableData}
                          enabledColumns={tableConfig.enabledColumns}
                          actions={tableConfig.actions}
                          onAction={handleTableAction}
                          currentPage={currentPage}
                          pageSize={pageSize}
                          onPageChange={(page) => setCurrentPage(page)}
                          showPagination={true}
                          totalElements={paginationData.totalElements}
                          totalPages={paginationData.totalPages}
                        />
                      </div>
                      <div
                        className="d-flex justify-content-between align-items-center flex-column flex-md-row w-100"
                        id="pagination"
                      >
                        <div className="mr-3 line_pagination px-2 px-md-0">
                          Showing {currentPage * pageSize + 1} to{" "}
                          {Math.min(
                            (currentPage + 1) * pageSize,
                            paginationData.totalElements
                          )}{" "}
                          of {paginationData.totalElements} entries
                        </div>
                        <div className="pages">
                          <PaginationComponent
                            currentPage={currentPage}
                            onPageChange={(page) => {
                              setCurrentPage(page);
                              handleSubmit(new Event('submit'));
                            }}
                            totalPages={paginationData.totalPages}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>


    </div>
  );
}
